export default __webpack_public_path__ + "static/media/contacts.d653cb39.png";